import { useMemo } from 'react';
import { getHumanName, getAgentId, processMessageContent, prepareMessageForSending, getHumanInitials } from '../config/agentIdentities';

export const useAgentIdentity = (agentId) => {
  const prospectKey = typeof window !== 'undefined'
    ? `${window.currentProspectName || ''}-${window.currentProspectEmail || ''}-${window.currentProspectImage || ''}`
    : '';

  const humanName = useMemo(() => getHumanName(agentId), [agentId, prospectKey]);
  const initials = useMemo(() => getHumanInitials(agentId), [agentId, prospectKey]);
  
  return {
    humanName,
    initials,
    getHumanName,
    getAgentId,
    processMessageContent,
    prepareMessageForSending
  };
};
